module.exports = __webpack_public_path__ + "static/media/Catalog.35849123.svg";